import { RouteInfo } from './sidebar.metadata';

// This is important: it is where you define the links in the sidebar for the app:
// Toggle the "adminOnly" flag to prevent the link from
// appearing in the UI to any user not contained in the admins array in the environment config
export const ROUTES: RouteInfo[] = [
    {
        path: '',
        title: 'Home',
        adminOnly: false,
        icon: 'ft-home',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/user-guide',
        title: 'User Guide',
        adminOnly: false,
        icon: 'ft-zap',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/interpreting-results',
        title: 'Interpreting FMV Results',
        adminOnly: false,
        icon: 'ft-info',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/glossary',
        title: 'Glossary of Terms',
        adminOnly: false,
        icon: 'ft-layers',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/methodology',
        title: 'FMV Hourly Rate Methodology',
        adminOnly: false,
        icon: 'ft-sliders',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    {
        path: '/terms-of-service',
        title: 'Terms of Service',
        adminOnly: false,
        icon: 'ft-unlock',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
    // {
    //     path: '/users/user-list',
    //     title: 'User Management',
    //     adminOnly: true,
    //     icon: 'ft-users',
    //     class: '',
    //     badge: '',
    //     badgeClass: '',
    //     isExternalLink: false,
    //     submenu: []
    // },
    // {
    //     path: '/forms/questionnaire-list',
    //     title: 'Past Calculations',
    //     adminOnly: false,
    //     icon: 'ft-list',
    //     class: '',
    //     badge: '',
    //     badgeClass: '',
    //     isExternalLink: false,
    //     submenu: []
    // },
    {
        path: '/forms/report-summary',
        title: 'Last Report Summary',
        adminOnly: false,
        icon: 'ft-clock',
        class: '',
        badge: '',
        badgeClass: '',
        isExternalLink: false,
        submenu: []
    },
];
